import shopDetailLegalPerson from './legalPerson'
import shopDetailAuthorization from './authorization'
import shopDetailContractInfo from './contractInfo'
import shopDetailContractPic from './contractPic'
import shopDetailContractRecord from './contractRecord'
import shopDetailSignSettleInfo from './signSettleInfo'
import shopDetailRemitSettleInfo from './remitSettleInfo'
import shopDetailTaxInfo from './taxInfo'
import shopDetailStartupMoney from './contractStartupMoney'
import shopDetailEquipmentInfo from './contractEquipmentInfo'

export default {
  shopDetailLegalPerson,          // 法人信息
  shopDetailAuthorization,        // 结算信息
  shopDetailContractInfo,         // 合同信息
  shopDetailContractPic,          // 合同照片
  shopDetailContractRecord,       // 合同记录
  shopDetailSignSettleInfo,       // 签字授权书
  shopDetailRemitSettleInfo,      // 打款授权书
  shopDetailTaxInfo,              // 纳税信息
  shopDetailStartupMoney,         // 启动费
  shopDetailEquipmentInfo         // 设备信息
}
